import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges, TemplateRef, ContentChild, ViewChild, ElementRef, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { retry } from 'rxjs/operators';
import { IOutputData } from '../../split/split.interface';
import { } from '../mosaic.component';
import { defaultNodeSettings } from '../../../pages/user/components/tile.helper';

export enum Direction {
	vertical,
	horizontal
}

export interface IMosaicNode {
	nodes: IMosaicNode[],
	data?: any,
	size?: number,
	settings?: any
}

export interface IMosaicNodeOut {
	index: number,
	node: IMosaicNode,
	settings?: any
}

export interface IMergeOut {
	childNode: IMosaicNodeOut,
	nodes: IMosaicNode[]
}

export const nodeSplitHelper = (node: IMosaicNode, defaultNode: IMosaicNode, defaultSettings: any = null): void => {
	node.nodes = [{
		...defaultNode,
		settings: { ...(defaultSettings || node.settings) },
		data: { ...node.data }
	}, {
		...defaultNode,
		settings: { ...(defaultSettings || node.settings) },
		data: { ...node.data }
	}];
	node.settings = undefined;
	node.data = undefined;
}


export const invertDirection = (direction: Direction): Direction =>
	direction == Direction.horizontal ?
		Direction.vertical :
		Direction.horizontal;

export const invertIndex = (index: number): number =>
	index == 1 ? 0 : 1;


export const defaultNode: IMosaicNode = {
	size: 50
} as IMosaicNode;

export const deepCopy = <T>(item: T): T => structuredClone(item);

enum TemplateType {
	None,
	User,
	Eidt,
	EidtRef
}

@Component({
	selector: 'mosaic-node',
	templateUrl: './mosaic-node.component.html',
	styleUrls: ['./mosaic-node.component.less']//,
	// changeDetection: ChangeDetectionStrategy.OnPush
})
export class MosaicNodeComponent implements OnChanges, OnInit, OnDestroy {

	invertDirection = invertDirection;

	@Input() node: IMosaicNode;
	@Input() isEdit: boolean = false;
	@Output("changed") settingsChangeEvent = new EventEmitter();
	@Output("dragged") draggedChangeEvent = new EventEmitter();
	@Output("deleteNode") deleteNodeEvent = new EventEmitter<IMosaicNodeOut>();
	@Output("mergeWithParent") mergeNodeEvent = new EventEmitter<IMergeOut>();

	@Input() template: TemplateRef<any> = {} as TemplateRef<any>;
	@Input() settingsTemplate: TemplateRef<any> = {} as TemplateRef<any>;
	@Input("editTemplate") editRefTemplate: TemplateRef<any> = {} as TemplateRef<any>;

	@Input() direction: Direction;
	@Input() level: number;
	@Input() index: number = -1;

	@ViewChild("editTemplate") editTemplate!: TemplateRef<any>;
/*	@ViewChild("splitContainer") splitContainer: ElementRef<Element>;*/

	public directionMap: any = Direction;
	public horizontalDirection = Direction.horizontal;
	public templateType: TemplateType;
	public templateTypeMap: any = TemplateType;

	dragging: boolean = false;

	constructor(private currentElement: ElementRef, private cdr: ChangeDetectorRef) {


	}
	ngOnDestroy(): void {
		/*console.log("MosaicNodeComponent ngOnDestroy");*/
	}

	ngOnInit(): void {
		/*console.log("MosaicNodeComponent ngOnInit");*/
	}

	ngOnChanges(changes: SimpleChanges): void {
	}

	splitterDragEnded = (event: IOutputData) => {
		this.dragging = false;
		this.node.nodes.forEach((item, index) => item.size = event.sizes[index] as number);
		this.nestedDragged();
		this.changed();
	}

	splitterDragStarted = (event: IOutputData) => {
		this.dragging = true;
	}

	nestedDragged = () => {
		this.draggedChangeEvent.emit();
	}

	changed = () => {
		this.settingsChangeEvent.emit();
	}

	changedNode = () => {

		this.changed();
	}

	addSplitNode = (event: IOutputData) => {

		this.node.nodes.forEach((s, index) => s.size = event.sizes[index] as number);
		this.node.nodes.splice(event.gutterNum, 0,
			{
				...defaultNode,
				settings: {
					... this.getFirstSettings(this.node.nodes[event.gutterNum]) || { ...defaultNodeSettings }
				},
				data: { ... this.node.nodes[event.gutterNum].data }
			});

		this.node.nodes = deepCopy(this.node.nodes);
		this.changed();
	}

	private getFirstSettings = (node: IMosaicNode): any => {
		if (node.settings != null)
			return node.settings;

		for (const item of node.nodes) {
			const settings = this.getFirstSettings(item);
			if (settings != null)
				return settings;
		}

		return null;
	}

	removeNodeEvent = (event: any, node: IMosaicNode) =>
		this.deleteNodeEvent.emit({
			index: this.index,
			node: node
		});

	splitNodeEvent = (event: any, node: IMosaicNode) => {
		nodeSplitHelper(this.node, defaultNode);
		this.changed();
	}

	mergeNode = (event: IMergeOut) => {
		let newNdoes = this.sizeCalc(this.node.nodes[event.childNode.index].size, event.nodes)
		this.node.nodes.splice(event.childNode.index, 1, ...newNdoes);
		this.changed();
	}

	private sizeCalc = (cellSize: number, nodes: IMosaicNode[]): IMosaicNode[] => {
		let k = cellSize / 100;
		return nodes.map(s => ({ ...s, size: s.size * k }));
	}

	deleteNode = (event: IMosaicNodeOut) => {

		if (this.node.nodes?.length == 2) {
			let reverseIndex = invertIndex(event.index);

			if (this.node.nodes[reverseIndex].nodes?.length > 1) {
				this.mergeNodeEvent.emit({
					childNode: {
						index: this.index,
						node: this.node
					},
					nodes: this.node.nodes[reverseIndex].nodes
				});
				return;
			}
			else {
				this.node.settings = this.node.nodes[event.index].settings;
				this.node.data = this.node.nodes[event.index].data;
				this.node.nodes = null;
			}

		}

		if (this.node.nodes?.length > 2)
			this.node.nodes.splice(event.index, 1);

		this.changed();
	}

	isVertiacalDirection = (direction: Direction): boolean => direction == Direction.vertical;

	getPanelSizes = (): number[] => this.node.nodes.map(s => s.size);


}
